var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_c('h1',[_vm._v("Unauthorised")]),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.logout}},[_c('span',{staticClass:"mr-2"},[_vm._v("sign out")]),_c('v-icon',[_vm._v("exit_to_app")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }